import {
    calculateQualifyingSubtotal,
    FREE_SHIPPING_THRESHOLD_US_CA,
    hasColdRxInCart,
    hasSTHInCart,
} from '@libs/common-next';
import type { CartUI } from '@libs/common-node';

export const FREE_SHIPPING_METER_TOTAL_MET = 'total met';

export function getFreeShippingMeterAnalyticsValue(cart: Maybe<CartUI>): string | null {
    // Mirror FreeShippingMeter UI eligibility: STH carts only, excluding cold Rx.
    if (!cart || (cart.summary?.itemCount ?? 0) === 0 || !hasSTHInCart(cart) || hasColdRxInCart(cart)) {
        return null;
    }

    const qualifyingSubtotal = calculateQualifyingSubtotal(cart);
    const amountAway = Math.max(0, FREE_SHIPPING_THRESHOLD_US_CA - qualifyingSubtotal);

    if (amountAway === 0) {
        return FREE_SHIPPING_METER_TOTAL_MET;
    }

    return `$${amountAway.toFixed(2)} away`;
}
